module.exports = __webpack_public_path__ + "static/media/decrease-icon.b7c35221.svg";